import React from 'react';
import { Link } from 'react-router-dom';
import { colors, semanticColors } from '../theme';

const Footer: React.FC = () => {
  return (
    <footer 
      className="w-full py-6 px-6 border-t mt-auto relative z-10"
      style={{ 
        backgroundColor: colors.primary, // Use header color (#2A333C)
        borderColor: colors.borderLight,
        color: colors.textInverted, // White text for better contrast
        minHeight: '80px', // Ensure minimum height
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)' // Add shadow for visibility
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center space-x-6 text-sm">
            <Link 
              to="/terms-of-service"
              className="hover:underline transition-colors duration-200 font-medium"
              style={{ color: colors.secondary }} // Use secondary color for links
            >
              Terms of Service
            </Link>
            <Link 
              to="/privacy-policy"
              className="hover:underline transition-colors duration-200 font-medium"
              style={{ color: colors.secondary }} // Use secondary color for links
            >
              Privacy Policy
            </Link>
          </div>
          <div className="text-center md:text-right text-xs" style={{ color: colors.textInverted }}>
            © 2025 Vital Hive Technologies LLC. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
